import React from 'react';

import moment from 'moment';

export interface UsageOverrideTooltipTextProps {
  value?: number;
  unitOfMeasure?: string;
  updatedBy?: string;
  updatedAt?: string;
  note?: string;
}

export const UsageOverrideTooltipText = ({
  value,
  unitOfMeasure,
  updatedBy,
  updatedAt,
  note,
}: UsageOverrideTooltipTextProps): JSX.Element => (
  <>
    Overridden to {value ?? '-'} {unitOfMeasure ?? ''} {updatedBy ? ` by ${updatedBy}` : ''} on{' '}
    {moment(updatedAt).format('MMM D YYYY')}.<br />
    {note ? `Note: ${note}.` : ''}
  </>
);
